import React from "react";
import styled from "styled-components";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";
import FinishedProductTable from "./FinishedProductTable";

const FinishedProduct = () => {
  return (
    <FinishedProductStyle>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        num3="محصولات تمام شده"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/products"
      />
      <FinishedProductTable />
    </FinishedProductStyle>
  );
};

const FinishedProductStyle = styled.div``;

export default FinishedProduct;
